import styled from '@emotion/styled';

import { ArrowLeft } from 'lucide-react';
import { Pages } from 'modules/navigation/domain/enums/pages';
import { Trans } from '@lingui/react/macro';
import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useMatch } from 'react-router-dom';
import { history, history as historyPage } from 'store/store';
import { selectHasChange } from 'modules/template-editor/store/editor/selectors';
import useNotionModal from 'modules/template-editor/ui/hooks/modals/notice';
import useLocalStorage from 'modules/template-editor/ui/hooks/use-local-storage';
import { theme } from 'styles/theme/theme';

function Header() {
  const hasChange = useSelector(selectHasChange);
  const { getData } = useLocalStorage();
  const { templateId: templateIdUrl } = useMatch(Pages.TEMPLATE.BOARDS + '/*')?.params ?? {};

  const handleGoBack = useCallback(() => {
    const { from, templateId: templateIdLocalStorage } = getData();
    switch (from) {
      case 'boards': {
        if (templateIdLocalStorage || templateIdUrl) {
          historyPage.push(Pages.TEMPLATE.builders.boards(templateIdLocalStorage ?? Number(templateIdUrl)));
        } else {
          historyPage.push(Pages.TEMPLATE.INDEX);
        }
        break;
      }
      case 'catalog': {
        if (templateIdLocalStorage) {
          history.push(Pages.TEMPLATE.CATALOG.builders.card(templateIdLocalStorage));
        } else {
          history.push(Pages.TEMPLATE.CATALOG.INDEX);
        }
        break;
      }
    }
  }, [getData, templateIdUrl]);

  const onClickBack = () => {
    if (hasChange) {
      open();
    } else {
      handleGoBack();
    }
  };

  const { modal, open } = useNotionModal({ onSuccess: handleGoBack });

  return (
    <MainBlock>
      <Button onClick={onClickBack}>
        <ArrowLeft strokeWidth={1} size={20} />{' '}
        <span>
          <Trans>Назад к списку</Trans>
        </span>
      </Button>
      {modal}
    </MainBlock>
  );
}

export default Header;

const MainBlock = styled.div`
  display: flex;
  flex-direction: row;
  height: 48px;
  min-height: 48px;
  background: ${theme.colors.SurfaceWhite};
  width: 100%;
  border-bottom: 1px solid ${theme.colors.DarkBlue100};
  padding-right: 15px;
`;

const Button = styled.button`
  border: none;
  background: none;
  cursor: pointer;
  width: 200px;
  padding-right: 20px;
  padding-left: 15px;

  display: flex;
  flex-direction: row;
  height: 100%;
  align-items: center;

  font-family: Inter, sans-serif;
  color: ${theme.colors.Black24};
  font-size: 11px;
  font-weight: 400;
  line-height: 16px;
  text-align: left;
  gap: 10px;

  transition: color 0.2s ease-in-out;

  &:hover {
    color: var(--color-darkYellow-500);
  }
`;
